import React, { useState, useEffect, FunctionComponent } from 'react';
import { Presentation } from './presentation';
import type { CompanyDetailTvsProps as Props } from './types';
import { getCompanyTvs } from '../../../services/companies'; 

export const Component: FunctionComponent<Props> = (props) => {
  const [tvIds, setTvIds] = useState<number[]>([]);

  useEffect(() => {
    let aborted = false;

    const fetchTvIds = async () => {
      try {
        const response = await getCompanyTvs(props.company.id);
        if (!aborted) setTvIds(response.tvIds || []);
      } catch (error) {
        console.log(error);
      }
    };

    fetchTvIds();
    return () => {
      aborted = true;
    };
  }, [props.company.id]);

  return (
    <Presentation
      tvIds={tvIds}
      company={props.company}
      dataCategory={props.dataCategory}
      dataValue={props.dataValue}
    />
  );
};
